import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { UsersThree, CheckCircle, GearSix } from "@phosphor-icons/react";
import ModalCloseButton from "../ui/ModalCloseButton";
import "./team.css";

/** Defaults the server wrote when the clinic flipped from solo → multi. */
const DEFAULTS = [
  "מטפלים רואים פיננסים ומפיקים חשבוניות (ייצוא נתונים — כבוי)",
  "שיוך מטופל לכמה מטפלים — פעיל",
  "מצב שיתוף מטופלים: מטופל משויך למטפל/ת",
  "חסימת כפל תורים למטפל/ת ותורים בזמן היעדרות — פעיל (מנהלים יכולים לעקוף)",
  "בתפריט הצד נפתח אזור 'ניהול הקליניקה'",
];

/**
 * Shown once on the Team page right after the first team member is added to a
 * solo clinic (`createTeamMember` resolved with `upgradedToMulti === true`).
 * Explains the multi-clinic defaults the server just wrote.
 */
function MultiClinicUpgradedModal({ onClose }) {
  const navigate = useNavigate();

  const goToSettings = () => {
    onClose?.();
    navigate("/dashboard/admin/settings");
  };

  const modal = (
    <div className="tm-overlay" onClick={onClose}>
      <div className="tm-modal narrow" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="tm-modal-header">
          <div className="tm-modal-title">
            <span className="tm-modal-title-icon">
              <UsersThree size={20} weight="fill" />
            </span>
            <div className="tm-modal-title-text">
              <span className="tm-eyebrow">צוות הקליניקה</span>
              <h3>הקליניקה שלך היא כעת קליניקה מרובת מטפלים</h3>
            </div>
          </div>
          <div className="tm-modal-header-actions">
            <ModalCloseButton onClick={onClose} />
          </div>
        </div>

        <div className="tm-body">
          <p className="tm-upgraded-intro">הגדרנו עבורך ברירות מחדל שאפשר לשנות בכל עת:</p>
          <ul className="tm-list">
            {DEFAULTS.map((label) => (
              <li key={label} className="tm-list-row tm-bullet-row">
                <CheckCircle size={16} weight="fill" />
                <span>{label}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="tm-footer">
          <button type="button" className="tm-btn secondary" onClick={goToSettings}>
            <GearSix size={16} weight="bold" />
            להגדרות שיתוף ומדיניות
          </button>
          <button type="button" className="tm-btn primary" onClick={onClose}>
            לעמוד הצוות
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
}

export default MultiClinicUpgradedModal;
